import React from 'react';

const ContentLiveCard = ({
  img,
  alt,
  badge,
  year,
  title,
  desc,
  techTags,
  plainTags,
  links,
  chromeLabel,
  delay = 0,
}) => (
  <article
    className="sc-live-card animate-fade-in"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="sc-live-preview">
      <div className="sc-browser-chrome">
        <div className="sc-browser-dots">
          <span className="sc-dot sc-dot--red"></span>
          <span className="sc-dot sc-dot--yellow"></span>
          <span className="sc-dot sc-dot--green"></span>
        </div>
        {chromeLabel && (
          <span className={`sc-chrome-label ${chromeLabel.className || ''}`}>
            {chromeLabel.icon && <i className={chromeLabel.icon}></i>}
            {chromeLabel.text}
          </span>
        )}
      </div>
      <div className="sc-browser-viewport">
        <img src={img} alt={alt || title} />
      </div>
    </div>

    <div className="sc-live-content">
      <div className="sc-live-meta">
        <span className="sc-type-badge">{badge}</span>
        {year && <span className="sc-year">{year}</span>}
      </div>
      <h3 className="sc-live-title">{title}</h3>
      <p className="sc-live-desc">{desc}</p>

      {techTags && techTags.length > 0 && (
        <div className="sc-tech-tags">
          {techTags.map((t, i) => (
            <span className={`label ${t.cls}`} key={i}>{t.label}</span>
          ))}
        </div>
      )}

      {plainTags && plainTags.length > 0 && (
        <div className="sc-plain-tags">
          {plainTags.map((tag, i) => (
            <span className="sc-tag" key={i}>{tag}</span>
          ))}
        </div>
      )}

      {links && links.length > 0 && (
        <div className="sc-links">
          {links.map((link, i) => (
            <a
              key={i}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`sc-link ${link.primary ? 'sc-link--primary' : ''} ${link.yt ? 'sc-link--yt' : ''}`}
            >
              {link.icon && <i className={link.icon}></i>}
              {link.label}
            </a>
          ))}
        </div>
      )}
    </div>
  </article>
);

export default ContentLiveCard;
